import { Logo } from 'foundations-components/transitional/components/Logo';
import { Image } from 'foundations-components/transitional/components/Image';
import { SprocketIcon } from 'foundations-assets/icons/components/SprocketIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const LogoBody = ({
  altText,
  showMobileView,
  imageSrc,
  height
}) => {
  if (showMobileView) {
    return /*#__PURE__*/_jsx(SprocketIcon, {
      color: "fill-accent-orange-default",
      size: "700"
    });
  }
  if (imageSrc) {
    return /*#__PURE__*/_jsx(Image, {
      alt: altText,
      blockSize: `${height || 40}px`,
      responsive: false,
      src: imageSrc
    });
  }
  return /*#__PURE__*/_jsx(Logo, {
    alt: altText,
    name: "hubspot-wordmark",
    width: "128px"
  });
};